import React, { Component } from 'react';
import Power_On_Off from './Components/Power_On_Off';
import Off_Timer from './Components/Off_Timer';
import Advanced_Settings from './Components/Advanced_Settings';
import RGB_Input from '../../../Part_Sample/RGB_Input';
import { getIcon } from '../../../Common/Common';
import { pushCommand, pushGroupCommand, isEmpty, addAnimation } from '../../../Common/Common';
import Error_Message from './Components/Error_Message';

export default class RGBWOperation extends Component {
	constructor(props) {
		super(props);

		let r = 0, g = 0, b = 0, h = 0;
		let rgb = "#000000"
		// let white_slider_value = 0;
		// let rgb_slider_value = 0;

		if (!isEmpty(this.props.point_info)) {
			if (this.props.point_info.rgbw != null) {
				let rgbw = this.props.point_info.rgbw; //get the rgbw value
				let hex = rgbw.toString(16); //convert decimal to hexadecimal
				let str = "";
				//Convert into proper 6 hexadecimals - add the missing 0s
				for (let i = 0; i < 8 - hex.length; i++) {
					str = "0" + str;
				}

				hex = str + hex;

				r = "0x" + hex.substring(0, 1) + hex.substring(1, 2);
				g = "0x" + hex.substring(2, 3) + hex.substring(3, 4);
				b = "0x" + hex.substring(4, 5) + hex.substring(5, 6);
				//w = "0x" + hex.substring(6, 7) + hex.substring(7, 8);
				r = +r; //Convert into decimal
				g = +g; //Convert into decimal
				b = +b; //Convert into decimal
				//w = +w; //Convert into decimal'

				r = r.toString(16);
				g = g.toString(16);
				b = b.toString(16);

				if (r.length == 1)
					r = "0" + r;
				if (g.length == 1)
					g = "0" + g;
				if (b.length == 1)
					b = "0" + b;

				rgb = "#" + r + g + b;

				// Converting r,g,b into h,s,l
				// Make r, g, and b fractions of 1
				// let x = r / 255;
				// let y = g / 255;
				// let z = b / 255;

				// let cmin = Math.min(x,y,z),
				// cmax = Math.max(x,y,z),
				// delta = cmax - cmin,
				// h = 0,
				// s = 0,
				// l = 0;

				// // Calculate hue
				// if (delta == 0){ // No difference
				// 	h = 0;
				// }
				// else if (cmax == x){// Red is max
				// 	h = ((y - z) / delta) % 6;
				// }
				// else if (cmax == y){ // Green is max
				// 	h = (z - x) / delta + 2;
				// }	
				// else{ // Blue is max
				// 	h = (x - y) / delta + 4;
				// }

				// h = Math.round(h * 60);

				// // Make negative hues positive behind 360°
				// if (h < 0){
				// 	h += 360;
				// }

				// rgb_slider_value = Math.round(h/360 * 100);

				// if(r == 255 && b == 0){ //0% - 17%
				// 	rgb_slider_value = Math.round(17 * Math.round((g * 100)/255)/100);
				// }else if(g == 255 && b == 0){ //18% -33%
				// 	rgb_slider_value = 17  + Math.round((Math.round(((255 - r) * 100)/255)* 16)/100);
				// }else if(r == 0 && g == 255){ //34% - 50%
				// 	rgb_slider_value = 33  + Math.round((Math.round((b * 100)/255)* 16)/100);
				// }else if(r == 0 && b == 255){ //51% - 67%
				// 	rgb_slider_value = 50  + Math.round((Math.round(((255 - g) * 100)/255)* 16)/100);
				// }else if(g == 0 && b == 255){ //68% - 83%
				// 	rgb_slider_value = 67  + Math.round((Math.round((r * 100)/255)* 16)/100);
				// }else if(r == 255 && g == 0){ //84% - 100%
				// 	rgb_slider_value = 83  + Math.round((Math.round(((255 - b) * 100)/255)* 16)/100);
				// }

				//white_slider_value = Math.round(w * 100 / 255); 
				//alert(r+" "+g+" "+b+" "+w);
			}
		}

		let on_off = 'off';
		if (this.props.point_info != null) {
			if (this.props.point_info.stat != null) {
				on_off = this.props.point_info.stat;
			}
		}

		this.state = {
			// h:h, //hue
			// r: r, //red
			// g: g, //green
			// b: b, //blue
			// w: w, //white
			// rgb_slider_value:rgb_slider_value,
			// white_slider_value:white_slider_value,
			rgb: rgb,
			on_off: on_off,
		}
	}

	//Send command to the controller
	handleSendCommand = (command, val) => {
		// Check whether it is a point operation or group operation
		if (this.props.group_id != null) {
			pushGroupCommand(command, val, this.props.group_id);
		} else if (this.props.point_id != null) {
			this.target_id = this.props.point_id;
			pushCommand(command, val, this.props.point_id);
		}
	}

	//Calculate final rgbw color code
	handleChangeColor = (hex_code) => {
		let command = 'rgbw'; //RGBW Change Color Command
		hex_code = hex_code + "FF"; //add W parameter
		hex_code = hex_code.substring(1); //remove # 
		let rgbw_code = parseInt(hex_code, 16); //Convert hex value to decimal value
		this.handleSendCommand(command, rgbw_code);
	}

	//Change warm white from range slider
	handleChangeWhite = (val) => {
		let w = Math.round(255 * (val / 100)); //get the decimal value from the percentage
		this.setState({
			white_slider_value: val,
			w: w
		})

		let r = this.state.r;
		let g = this.state.g;
		let b = this.state.b;

		//Converting RGB to hexadecimal
		r = r.toString(16);
		g = g.toString(16);
		b = b.toString(16);
		w = w.toString(16);

		if (r.length == 1)
			r = "0" + r;
		if (g.length == 1)
			g = "0" + g;
		if (b.length == 1)
			b = "0" + b;
		if (w.length == 1)
			w = "0" + w;

		this.handleChangeColor("" + r + g + b + w);
	}

	//Change rgb color
	handleOnChangeRGB = (val) => {

		this.setState({
			rgb: val
		})

		// let h = Math.round(val * 360/ 100);
		// let s = 1;
		// let l = 50/100;

		// let c = (1 - Math.abs(2 * l - 1)) * s,
		// x = c * (1 - Math.abs((h / 60) % 2 - 1)),
		// m = l - c/2,
		// r = 0,
		// g = 0,
		// b = 0;

		// if (0 <= h && h < 60) {
		// 	r = c; g = x; b = 0;  
		//   } else if (60 <= h && h < 120) {
		// 	r = x; g = c; b = 0;
		//   } else if (120 <= h && h < 180) {
		// 	r = 0; g = c; b = x;
		//   } else if (180 <= h && h < 240) {
		// 	r = 0; g = x; b = c;
		//   } else if (240 <= h && h < 300) {
		// 	r = x; g = 0; b = c;
		//   } else if (300 <= h && h < 360) {
		// 	r = c; g = 0; b = x;
		//   }

		// r = Math.round((r + m) * 255);
		// g = Math.round((g + m) * 255);
		// b = Math.round((b + m) * 255);

		// let r =0, g =0, b=0;
		// if(val < 18){ //0 - 17 -> change g
		// 	r = 255;
		// 	g = Math.round(255 * (Math.round((val * 100)/17)) /100); 
		// 	b = 0;
		// }else if(val <34){ //18 - 33 -> change r
		// 	r = Math.round(255 * (100 - (Math.round((val * 100)/33))) /100); 
		// 	g = 255;
		// 	b = 0;
		// }else if(val < 51){ //34 - 50 -> change b
		// 	r = 0
		// 	g = 255;
		// 	b = Math.round(255 * (Math.round((val * 100)/50)) /100); 
		// }else if(val < 68){ //51 - 67 -> change g
		// 	r = 0
		// 	g = Math.round(255 * (100 - (Math.round((val * 100)/67))) /100); 
		// 	b = 255;
		// }else if(val < 84){ //68 - 83 -> change r
		// 	r = Math.round(255 * (Math.round((val * 100)/83)) /100); 
		// 	g = 0
		// 	b = 255;
		// }else{ //84 - 100 -> change b
		// 	r = 255
		// 	g = 0;
		// 	b = Math.round(255 * (100 - (Math.round((val * 100)/100))) /100); 
		// }

		// this.setState({
		// 	r:r,
		// 	g:g,
		// 	b:b,
		// 	h:h,
		// 	rgb_slider_value:val
		// })

		//Converting RGB to hexadecimal
		// r = r.toString(16);
		// g = g.toString(16);
		// b = b.toString(16);

		// let w = this.state.w;	
		// w = w.toString(16);
		// if (r.length == 1)
		// 	r = "0" + r;
		// if (g.length == 1)
		// 	g = "0" + g;
		// if (b.length == 1)
		// 	b = "0" + b;
		// if (w.length == 1)
		// 	w = "0" + w;

		//this.handleChangeColor(""+r+g+b);	
		this.handleChangeColor(val);
	}

	handleOnOff = () => {
		let val = 'off';
		let elem = document.getElementById('icon_container');

		if (this.state.on_off == 'off') {
			val = 'on';
			addAnimation(elem, 'fadeInLong', () => { }, 2000)
			this.setState({ on_off: 'on' });
		} else {
			addAnimation(elem, 'fadeOutLongFast', () => {
				this.setState({ on_off: 'off' });
			}, 200)
		}
		let command = 'stat';
		pushCommand(command, val, this.props.point_id);
	}

	handleToggleOffTimer = (val) => {
		let command = 'off_timer';
		pushCommand(command, val, this.props.point_id);
	}

	render() {

		let icon = null;
		let icon_width = 50;
		let power_icon_width = 150
		let background_gradient = 'radial-gradient(#8dff95 5%, #daffda 50%, #fffcfc 70%)';
		let error_message = '';
		let is_show_error_message = false;
		let icon_container_style = {
			width: icon_width + 30,
			height: icon_width + 30,
			position: 'absolute',
			top: -(power_icon_width + 10),
			left: 20,
			backgroundImage: background_gradient,
			display: this.state.on_off == 'on' ? 'block' : 'none',
		}

		let op_button_cell_style = {
			width: 80,
			height: 80,
			margin: 5,
			padding: 10,
			backgroundColor: 'white',
			borderRadius: 20,
			boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
			fontSize: 11,
		}

		if (this.props.point_id != null && !isEmpty(this.props.point_info)) {
			icon = getIcon(this.props.point_info.icon, this.props.point_info.stat);

			if (this.props.point_info.error != null) {
				//check if device has device error
				let device_error = this.props.point_info.error;
				for (var key in device_error) {
					if (device_error[key]) {
						error_message = key;
						is_show_error_message = true;
					}
				}
			}
		}

		return (
			<div id='rgbw_operation' >
				{/* If group operation, hide component */}
				{this.props.group_id == null ?
					<div style={{ cursor: 'pointer', }} onClick={this.handleOnOff}>
						{/* Power On Off Button */}
						<div style={{ verticalAlign: 'top', marginTop: 20 }}>
							<Power_On_Off
								style={{}}
								img_width={power_icon_width}
								receiver={this.props.receiver}
								point_info={this.props.point_info}
								on_off={this.state.on_off} />
						</div>
						{/* Point icon */}
						<div style={{ position: 'relative' }}>
							<div id='icon_container' style={icon_container_style}></div>
							<img id={'device_icon'} src={icon} alt='icon' style={{ width: icon_width, opacity: 0.6, position: 'absolute', top: -(power_icon_width - 5), left: 35, }} />
						</div>
					</div> : null}
				{/* Error Message */}
				{is_show_error_message ?
					<div id='error_message'>
						<Error_Message
							deviceErrorMessage={error_message}
						/>
					</div> : null}

				{/* RGB Slider */}
				<div style={{ marginTop: 20 }}>
					<RGB_Input
						title={this.props.receiver.getString('color')}
						value={this.state.rgb}
						handleOnChangeRGB={this.handleOnChangeRGB}
					/>
				</div>

				{/* Off Timer */}
				<div style={{ marginTop: 10 }}>
					<div style={{ display: this.props.receiver.active_controller.user_class == 'Admin' && this.props.point_id != null ? 'inline-block' : 'none', verticalAlign: 'top' }}>
						<Off_Timer
							style={op_button_cell_style}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleToggleOffTimer={this.handleToggleOffTimer}
						/>
					</div>
				</div>
				<div style={{ display: this.props.receiver.active_controller.user_class == 'Admin' && this.props.point_id != null ? 'inline-block' : 'none', marginTop: 10 }}>
					<Advanced_Settings
						point_id={this.props.point_id}
						point_info={this.props.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
						colours={this.props.colours}
					/>
				</div>
			</div>
		)
	}
}